import { render, staticRenderFns } from "./BcAddressSelector.vue?vue&type=template&id=11567f8e"
import script from "./BcAddressSelector.vue?vue&type=script&lang=js"
export * from "./BcAddressSelector.vue?vue&type=script&lang=js"
import style0 from "./BcAddressSelector.vue?vue&type=style&index=0&id=11567f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports